import React, { useState } from 'react';
import Bitcoins from '../../../../assets/bitcoins-signup.svg';
import Logo from '../../../../assets/logo-novo-cointimes.svg';
import { useForm, FormProvider } from '../../../../hooks/form';
import { Input, Button } from '../../../UI';
import Link from 'next/link';
import MailIcon from '../../../../assets/mail.svg';
import { Container } from '../../../../styles/pages/login/styles';
import { CircularProgress } from '@mui/material';
import { useForgotPassword } from '../../../../hooks/forgotPassword';
import { t } from 'i18next';

interface StepProps {
  formStep?: number;
  nextFormStep: () => void;
  setErrorCode: (value: string) => void;
}

const EmailField: React.FC<StepProps> = ({
  formStep,
  nextFormStep,
  setErrorCode,
}) => {
  const { setFormValues, putEmail } = useForgotPassword();
  const [loading, setLoading] = useState(false);

  const methods = useForm();
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = async values => {
    try {
      setLoading(true);
      await putEmail(values?.user_email);
      setFormValues(values);
      nextFormStep();
      setLoading(false);
      setErrorCode('');
    } catch (err) {
      setLoading(false);
      console.log(`request failed: ${err}`);
    }
  };

  return (
    <div className="rightContent">
      <Link href="/" passHref>
        <div className="logo">
          <Logo height={60} />
        </div>
      </Link>
      <span className="subTitle">{t('pages.forgot-password.forgot-password-message')}</span>
      <FormProvider {...methods}>
        <form className="register" onSubmit={handleSubmit(onSubmit)}>
          <div className="alignInput">
            <div style={{ margin: '0.8rem 0' }}>
              <Input.Default
                icon={<MailIcon />}
                type="text"
                placeholder={t('pages.forgot-password.email-input')}
                registerField={{
                  name: 'user_email',
                  options: {
                    required: t('pages.forgot-password.email-input-required'),
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: t('pages.forgot-password.email-input-invalid'),
                    },
                  },
                }}
              />
            </div>
            {errors.user_email && (
              <span className="error">{errors.user_email.message}</span>
            )}
            <Button className="formButton" type="submit">
              {loading ? (
                <CircularProgress size={24} className="loading" />
              ) : (
                t('pages.forgot-password.send-code-button')
              )}
            </Button>
          </div>
        </form>
      </FormProvider>

      <div className="alignDivider">
        <div className="divider"></div>
        <span>{t('or')}</span>
        <div className="divider"></div>
      </div>
      <Link href="/signup" passHref>
        <span className="subTitle orange">{t('pages.forgot-password.create-new-account')}</span>
      </Link>
    </div>
  );
};

export default EmailField;
